var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"value":_vm.myValue}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.items),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }